import { Flex } from 'antd';
import { PropsWithChildren } from 'react';

import { useAppContext } from 'business/contextProviders/useAppContext';
import config from 'config';
import AppLogo from 'ui/appLogo';

import styles from './index.module.scss';

export const PrintHeader = ({ children }: PropsWithChildren) => {
  const { currentConstructionSite } = useAppContext();

  return (
    <Flex vertical className={styles.header}>
      <Flex justify="center" gap={20}>
        <AppLogo />
        {currentConstructionSite?.logo ? (
          <AppLogo
            alt="Construction site logo"
            path={`${config.gcp.publicUri}/${currentConstructionSite.logo}`}
          />
        ) : null}
      </Flex>
      {currentConstructionSite?.name ? (
        <h1 className={styles.constructionSiteName}>
          {currentConstructionSite?.name}
        </h1>
      ) : null}
      {children}
    </Flex>
  );
};
